import React, { FC, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router';

import { EvLinkNavigationTabs, IMenuOption } from '@evinced-private/ui-common';

import { TABS_DAID } from 'data-automation-ids/data-automation-ids';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MFA_SINGLE_SESSION_TABS_LABELS } from './MfaSingleSessionTabs.labels';

interface IMfaSingleSessionTabsProps {
	viewId?: SessionViews;
	sessionId: string;
}

export const MfaSingleSessionTabs: FC<IMfaSingleSessionTabsProps> = ({
	sessionId,
	viewId = SessionViews.OVERVIEW
}) => {
	const history = useHistory();
	const { configuration } = useConfiguration();

	const showScansTab = configuration?.PLATFORM?.DEV_TOGGLES?.ENABLE_MOBILE_SCANS_VIEW ?? false;

	const handleTabClick = useCallback(
		(tabViewId: SessionViews): void =>
			history.push(RoutesHelper.getMfaSessionPath(sessionId, tabViewId)),
		[history, sessionId]
	);

	const options: IMenuOption[] = useMemo(
		() => [
			{
				id: SessionViews.OVERVIEW,
				title: MFA_SINGLE_SESSION_TABS_LABELS.OVERVIEW,
				onClick: () => handleTabClick(SessionViews.OVERVIEW)
			},
			...(showScansTab
				? [
						{
							id: SessionViews.SCANS,
							title: MFA_SINGLE_SESSION_TABS_LABELS.SCANS,
							onClick: () => handleTabClick(SessionViews.SCANS)
						}
					]
				: []),
			{
				id: SessionViews.ALL_ISSUES,
				title: MFA_SINGLE_SESSION_TABS_LABELS.ALL_ISSUES,
				onClick: () => handleTabClick(SessionViews.ALL_ISSUES)
			}
		],
		[handleTabClick, showScansTab]
	);

	return (
		<div data-automation-id={TABS_DAID}>
			<EvLinkNavigationTabs selectedTabId={viewId} options={options} />
		</div>
	);
};
